import { SelectProps } from "@cloudscape-design/components-themed";

// 再審査指示・判定画面のラベル
export const LABELS = {
  EXAMINATION_APPLICATION_NO: "審査申請番号",
  APPLICATION_NO: "申請No",
  APPLICATION_DATE: "申請日",
  APPLICATION_MANAGER: "申請担当",
  APPLICATION_TYPE: "申請種別",
  REGISTER_NAME: "親事業者名",
  COMPANY: "事業者",
  CORPORATE_NUMBER: "法人番号",
  GROUP_NAME: "加盟店名",
  CONTRACT_SERVICE: "契約サービス",
  CONTRACT_ROUTE: "契約ルート",
  SUB_TITLE_LEFT: "再審査対象選定・指示",
  ORDER_TARGET: "仕向け先",
  REQUEST_DATE: "依頼日",
  EXAMINATION_ORDER_TARGET_STATUS: "審査状況",
  EXAMINATION_TARGET: "審査対象",
  RE_EXAMINATION_REASON: "再審査理由",
  SUB_TITLE_RIGHT: "審査結果判定",
  D_PAYMENT_BARCODE: "ｄ払い（バーコード）",
  D_PAYMENT_INTERNET: "ｄ払い（ネット）",
  CONTRACT_DIRECTLY: "直接",
  AMEX: "AMEX",
  JCB: "JCB",
  V_M_TF: "V/M（TF）",
  V_M_SMCC: "V/M（SMCC）",
  V_M_SAISON: "V/M（セゾン）",
  REQUEST_WAITING: "依頼待ち",
  UNDER_REVIEW: "審査中",
  EXAMINATION_NG: "審査NG",
  EXAMINATION_OK: "審査OK",
  V_M: "V/M",
  TF: "TF",
  SMCC: "SMCC",
  SAISON: "セゾン",
};
// 仕向け先一覧IF
export interface IOrderTargetItems {
  orderTarget: string;
  requestDate: string;
  examinationOrderTargetStatus: number;
  isApplied?: boolean;
  displayOrder: number;
}
//審査種別: 店舗
export const APPLICATION_TYPE_STORES = [12, 22];
// コメント最大文字数
export const COMMENT_MAX_LENGTH = 500;
// ステータスIF
interface IStatusObj {
  code: number;
  label: string;
}
// 契約サービス
interface IContractService {
  dPaymentBarcode: IStatusObj;
  dPaymentInternet: IStatusObj;
}
export const CONTRACT_SERVICE: IContractService = {
  dPaymentBarcode: {
    code: 1,
    label: LABELS.D_PAYMENT_BARCODE,
  },
  dPaymentInternet: {
    code: 2,
    label: LABELS.D_PAYMENT_INTERNET,
  },
};
// 審査ステータス
interface IExaminationStatus {
  examinationAwaiting: IStatusObj;
  reviewResultsAwaiting: IStatusObj;
  examinationNg: IStatusObj;
  examinationOk: IStatusObj;
}
export const EXAMINATION_STATUS: IExaminationStatus = {
  examinationAwaiting: {
    code: 101,
    label: LABELS.REQUEST_WAITING,
  },
  reviewResultsAwaiting: {
    code: 102,
    label: LABELS.UNDER_REVIEW,
  },
  examinationNg: {
    code: 201,
    label: LABELS.EXAMINATION_NG,
  },
  examinationOk: {
    code: 301,
    label: LABELS.EXAMINATION_OK,
  },
};

export const V_M_BRANDS: SelectProps.Option[] = [
  {
    value: "1",
    label: LABELS.SMCC,
  },
  {
    value: "3",
    label: LABELS.TF,
  },
  {
    value: "2",
    label: LABELS.SAISON,
  },
];
